import { Stack, TextField } from "@mui/material";
import { OTP_V2_RESEND } from "../../../../config/urls";
import { setLastSandboxResult, useLastSandboxResult, useOtpApi } from "../../otpApi";
import OtpTestApi from "./OtpTestApi";
import {
  END_FAILED,
  HelperText,
  MappingRow,
  OutputsTable,
  ReadOnlyField,
  SectionTitle,
  SubSection,
} from "./OtpPanelParts";

const OUTPUTS = [
  { response: "200", detail: "New code sent", route: "Verify OTP" },
  { response: "429 cooldown_active", detail: "Asked too soon; cooldown message sent", route: "Verify OTP" },
  { response: "429 resend_limit_reached", detail: "No resends left", route: END_FAILED },
  { response: "429 rate_limited", detail: "Per-number hourly or daily limit", route: END_FAILED },
  { response: "402 / 422 / 502", detail: "Balance, template or WhatsApp failure", route: END_FAILED },
];

const OtpResendPreset = ({ config, handleConfigChange }) => {
  const callApi = useOtpApi();
  const lastSandbox = useLastSandboxResult();

  const runTest = async () => {
    const result = await callApi(OTP_V2_RESEND, {
      body: { otp_ref_id: lastSandbox.otp_ref_id },
    });
    if (result.status === 200) setLastSandboxResult(result.body);
    return result;
  };

  return (
    <Stack spacing={3}>
      <SectionTitle>API</SectionTitle>
      <SubSection>
        <ReadOnlyField label="Endpoint" value="POST {BASE_HOST_URL}/api/v2/otp/resend/" />
        <ReadOnlyField label="Connection" value="OTP API Connection" />
      </SubSection>

      <SectionTitle>Request Body</SectionTitle>
      <SubSection>
        <MappingRow name="otp_ref_id">
          <TextField
            size="small"
            label="Value"
            value={config.otp_ref_id ?? "{{otp_ref_id}}"}
            onChange={(event) => handleConfigChange("otp_ref_id", event.target.value)}
          />
        </MappingRow>
      </SubSection>

      <SectionTitle>Response Mapping</SectionTitle>
      <SubSection>
        <MappingRow name="otp_ref_id" arrow="→">
          <TextField
            size="small"
            label="Store As"
            value={config.store_ref_as ?? "otp_ref_id"}
            onChange={(event) => handleConfigChange("store_ref_as", event.target.value)}
          />
        </MappingRow>
        <MappingRow name="expires_at" arrow="→">
          <TextField
            size="small"
            label="Store As"
            value={config.store_expires_as ?? "otp_expires_at"}
            onChange={(event) => handleConfigChange("store_expires_as", event.target.value)}
          />
        </MappingRow>
      </SubSection>

      <SectionTitle>Outputs</SectionTitle>
      <OutputsTable rows={OUTPUTS} />

      <TextField
        label="Cooldown Message"
        value={config.cooldown_message ?? "You can request a new code in {{seconds_left}} s."}
        onChange={(event) => handleConfigChange("cooldown_message", event.target.value)}
        helperText="Cooldown and max resends are set in your business's OTP settings."
      />

      <OtpTestApi
        onRun={runTest}
        disabled={!lastSandbox}
        disabledReason="Run Test API on Send OTP first."
      >
        <HelperText>
          A resend right after a Send test returns cooldown_active, which is the expected result
          until the cooldown has passed.
        </HelperText>
      </OtpTestApi>
    </Stack>
  );
};

export default OtpResendPreset;
